<app-nav-bar></app-nav-bar>

<div class="max-w-[1360px] mx-auto px-5 md:py-7 lg:py-10">
    <div class="grid grid-cols-12 gap-[30px]">
        <div class="col-span-12 lg:col-span-8">
            <div class="flex flex-col md:flex-row justify-between pb-5 border-b border-secondary-button-black gap-4">
                <h1 class="text-[26px] text-black font-medium">Leaderboard</h1>
                <div class="flex flex-wrap items-center gap-5">
                    <ul class="flex items-center gap-3.5">
                        <li *ngFor="let tab of tabs" (click)="setActiveTab(tab)"
                            class="cursor-pointer text-base !leading-3 font-normal pt-2.5 pb-2 px-3.5 rounded-full border transition-all"
                            [ngClass]="
                            activeTab === tab
                                ? 'text-black bg-secondary-button-black font-semibold border-black'
                                : 'text-secondary-text-black border-transparent hover:bg-secondary-button-black'
                            ">
                            {{ tab }}
                        </li>
                    </ul>
                    <div class="relative inline-block">
                        <button (click)="toggleDropdown()"
                            class="w-[190px] flex items-center justify-between gap-3 text-black text-base lg:text-lg font-medium border border-secondary-button-black rounded-lg px-4 py-3 cursor-pointer">
                            {{ selectedCategory }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="transition-transform duration-200"
                                [ngClass]="{ 'rotate-180': isOpen }">
                                <path d="M11.7344 6.40042C11.7344 6.40042 8.78844 10.4004 7.73438 10.4004
                                C6.68024 10.4004 3.73438 6.40039 3.73438 6.40039" stroke="black" stroke-opacity="0.8"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                        <ul *ngIf="isOpen"
                            class="absolute z-10 w-[190px] border border-secondary-button-black rounded-lg mt-1.5 bg-white shadow-lg">
                            <li *ngFor="let category of categories" (click)="selectCategory(category)" class="text-base lg:text-lg font-medium !leading-2.5 py-4 px-[18px]
                             border-b last:border-b-0 border-secondary-button-black
                             hover:bg-light-black-300 duration-200 ease-in-out cursor-pointer">
                                {{ category.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="mt-6">
                <!-- Data Display -->
                <div
                    class="flex flex-col md:flex-row items-end justify-between pt-6 pb-3.5 gap-4 border-b border-secondary-button-black">
                    <div class="flex items-end gap-3.5 w-full md:w-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M18.5 18.5L22 22M21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C16.7467 21 21 16.7467 21 11.5Z"
                                stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <input type="text" placeholder="Search by name" [(ngModel)]="searchQuery"
                            (ngModelChange)="onSearchChange()"
                            class="text-lg font-normal text-black w-full !leading-3 placeholder:text-secondary-text-black border-0 outline-none py-0" />
                    </div>
                    <div class="flex items-center gap-[30px]">
                        <button (click)="setProfitTab('profit')"
                            class="text-base md:text-lg lg:text-xl font-medium pb-3.5 cursor-pointer border-b-2 transition-all"
                            [ngClass]="activeProfitTab === 'profit' ? 'text-black border-primary-text-green' : 'text-secondary-text-black border-transparent'">
                            Profit/Loss
                        </button>
                        <span
                            class="text-base md:text-lg lg:text-xl inline-block text-secondary-button-black font-medium pb-3.5">|</span>
                        <button (click)="setProfitTab('volume')"
                            class="text-base md:text-lg lg:text-xl font-medium pb-3.5 cursor-pointer border-b-2 transition-all"
                            [ngClass]="activeProfitTab === 'volume' ? 'text-black border-primary-text-green' : 'text-secondary-text-black border-transparent'">
                            Volume
                        </button>
                    </div>
                </div>

                <div *ngIf="!loading; else loader">
                    <div *ngFor="let item of leaderboardData; let i = index">
                        <div [routerLink]="['/leaderboard-details']" [queryParams]="{ user_id: item.user_id || item.id }"
                            class="flex items-center justify-between p-4 cursor-pointer hover:bg-light-black-300 rounded-xl duration-200 ease-in-out">
                            <div class="flex items-center gap-4">
                                <span class="text-black text-lg font-medium min-w-[24px]">{{ item.rank || i + 1
                                    }}</span>
                                <span class="flex items-center justify-center w-10 h-10 rounded-full bg-secondary-button-black text-black font-bold uppercase"
                                    *ngIf="!item.profile_picture">
                                    {{ item.username?.charAt(0) }}
                                </span>
                                <img [src]="item.profile_picture" *ngIf="item.profile_picture"
                                    class="w-10 h-10 rounded-full" />
                                <div class="relative group">
                                    <p class="text-lg font-medium !leading-3 text-black group-hover:underline">{{
                                        shortenUsername(item.username) }}</p>

                                    <!-- Hover Popover using Global Keys -->
                                    <div
                                        class="w-[296px] bg-white absolute top-full -left-4 z-50 mt-2 border border-secondary-button-black rounded-[15px] p-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 ease-in-out shadow-xl">
                                        <div class="flex items-center gap-4">
                                            <div class="flex items-center justify-center w-11 h-11 rounded-full bg-secondary-button-black text-black font-bold uppercase"
                                                *ngIf="!item.profile_picture">
                                                {{ item.username?.charAt(0) }}
                                            </div>
                                            <img [src]="item.profile_picture" *ngIf="item.profile_picture"
                                                alt="profile" class="w-11 h-11 rounded-full">
                                            <div class="flex flex-col">
                                                <h4 class="text-base text-black font-medium">{{
                                                    shortenUsername(item.username) }}</h4>
                                                <p class="text-secondary-text-black text-xs font-medium">Joined {{ (item.created_at | date:'MMM yyyy') }}
                                                </p>
                                            </div>
                                        </div>
                                        <span class="block w-full h-px bg-secondary-button-black my-5"></span>
                                        <div class="grid grid-cols-3 gap-5">
                                            <div class="flex flex-col gap-2">
                                                <p class="text-black text-base font-medium !leading-3">{{
                                                    item.global_positions || '0.00' }}</p>
                                                <p class="text-xs font-medium text-secondary-text-black">Positions</p>
                                            </div>
                                            <div class="flex flex-col gap-2">
                                                <p [ngClass]="(item.global_pnl >= 0) ? 'text-primary-text-green' : 'text-primary-text-yellow'"
                                                    class="text-base font-medium !leading-3">
                                                    {{ (item.global_pnl >= 0 ? '+' : '-') }}${{ (item.global_pnl < 0 ?
                                                        -item.global_pnl : item.global_pnl) | number:'1.0-0' }} </p>
                                                        <p class="text-xs font-medium text-secondary-text-black">
                                                            Profit/loss</p>
                                            </div>
                                            <div class="flex flex-col gap-2">
                                                <p class="text-black text-base font-medium !leading-3">{{ '$' +
                                                    (item.global_volume | number:'1.0-0') }}</p>
                                                <p class="text-xs font-medium text-secondary-text-black">Volume</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between gap-[30px] min-w-60">
                                <p class="text-lg font-medium !leading-3"
                                    [ngClass]="(item.pnl >= 0) ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                    {{ (item.pnl >= 0 ? '+' : '-') }}${{ (item.pnl < 0 ? -item.pnl : item.pnl) |
                                        number:'1.2-2' }} </p>
                                        <p class="text-lg font-medium !leading-3"
                                            [ngClass]="activeProfitTab === 'volume' ? 'text-black' : 'text-secondary-text-black'">
                                            {{ '$' + (item.volume | number:'1.2-2') }}
                                        </p>
                            </div>
                        </div>
                        <span class="block w-full h-px bg-secondary-button-black my-2.5 mx-4"></span>
                    </div>

                    <!-- Logged-in User Row -->
                    <div *ngIf="userStats" [routerLink]="['/leaderboard-details']" [queryParams]="{ user_id: userStats.user_id || userStats.id }"
                        class="mt-8 bg-gray-50 border-t-2 border-primary-text-green/20 p-5 rounded-2xl shadow-sm cursor-pointer hover:bg-gray-100 duration-200">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-4">
                                <span class="text-black text-lg font-bold min-w-[24px]">#{{ userStats.rank }}</span>
                                <div class="relative">
                                    <div class="flex items-center justify-center w-11 h-11 rounded-full bg-secondary-button-black text-black font-bold uppercase border-2 border-white shadow-sm"
                                        *ngIf="!userStats.profile_picture">
                                        {{ userStats.username?.charAt(0) }}
                                    </div>
                                    <img [src]="userStats.profile_picture" *ngIf="userStats.profile_picture"
                                        class="w-11 h-11 rounded-full border-2 border-white shadow-sm" />
                                    <div
                                        class="absolute -bottom-1 -right-1 bg-primary-text-green w-4 h-4 rounded-full border-2 border-white">
                                    </div>
                                </div>
                                <div class="flex flex-col">
                                    <p class="text-lg font-bold text-black leading-none">Me ({{
                                        shortenUsername(userStats.username) }})</p>
                                    <span class="text-xs text-secondary-text-black mt-1">Current Ranking</span>
                                </div>
                            </div>
                            <div class="flex items-center justify-between gap-[30px] min-w-60">
                                <p class="text-xl font-bold"
                                    [ngClass]="(userStats.pnl >= 0) ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                    {{ (userStats.pnl >= 0 ? '+' : '-') }}${{ (userStats.pnl < 0 ? -userStats.pnl :
                                        userStats.pnl) | number:'1.2-2' }} </p>
                                        <p class="text-xl font-bold"
                                            [ngClass]="activeProfitTab === 'volume' ? 'text-black' : 'text-secondary-text-black'">
                                            {{ '$' + (userStats.volume | number:'1.2-2') }}
                                        </p>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="leaderboardData.length === 0"
                        class="py-20 text-center text-secondary-text-black text-lg">
                        No leaderboard data found.
                    </div>
                </div>

                <ng-template #loader>
                    <div class="py-20 flex justify-center items-center">
                        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-black"></div>
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Right Side Stats (Static for now as per original UI) -->
        <div class="col-span-12 lg:col-span-4 mt-10 lg:mt-0">
            <div class="sticky top-4">
                <div class="p-5 border border-secondary-button-black rounded-[14px] relative">
                    <h2 class="text-black text-lg md:text-xl font-medium mb-6">Biggest wins this month</h2>

                    <div class="flex flex-col gap-5">
                        <div *ngIf="topWinsLoading" class="py-8 flex justify-center items-center">
                            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
                        </div>

                        <div *ngFor="let item of topWinsData.slice(0, 5); let i = index" class="flex flex-col">
                            <div class="flex items-center gap-4">
                                <div class="flex items-center gap-3.5">
                                    <span class="text-secondary-text-black text-lg font-medium">{{ i + 1 }}</span>
                                    <div class="flex items-center justify-center w-[30px] h-[30px] rounded-full bg-secondary-button-black text-black font-bold text-xs uppercase"
                                        *ngIf="!item.profile_picture">
                                        {{ item.username?.charAt(0) }}
                                    </div>
                                    <img [src]="item.profile_picture" *ngIf="item.profile_picture"
                                        alt="profile" class="w-[30px] h-[30px] rounded-full" />
                                </div>
                                <div class="w-[calc(100%-66px)] flex flex-col gap-2">
                                    <div class="flex items-center gap-2.5">
                                        <h3 class="text-black text-base font-medium">{{ shortenUsername(item.username)
                                            }}</h3>
                                        <span class="text-xl text-light-black-200">|</span>
                                        <h4 class="text-secondary-text-black text-base font-medium line-clamp-1">{{
                                            item.market_name || 'Top Win' }}</h4>
                                    </div>
                                    <div class="flex items-center gap-2.5">
                                        <p class="text-black text-base font-normal !leading-3">{{
                                            formatCurrency(item.winning_amount, '1.0-0') }}</p>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                viewBox="0 0 14 14" fill="none">
                                                <path d="M10.793 7L2.91797 7" stroke="black" stroke-opacity="0.5"
                                                    stroke-width="0.875" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M7.58398 3.5C7.58398 3.5 11.0839 6.07769 11.084 7C11.084 7.92237 7.58398 10.5 7.58398 10.5"
                                                    stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                        <p class="text-base font-normal !leading-3"
                                            [ngClass]="item.profit >= 0 ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                            {{ item.profit >= 0 ? '+' : '-' }}{{ formatCurrency(item.profit >= 0 ?
                                            item.profit : -item.profit, '1.0-0') }}</p>
                                    </div>
                                </div>
                            </div>
                            <span *ngIf="i < 4" class="block w-full h-px bg-secondary-button-black my-5"></span>
                        </div>

                        <div *ngIf="!topWinsLoading && topWinsData.length === 0"
                            class="py-6 text-center text-secondary-text-black text-base">
                            No top wins data found.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>